import React from 'react';
import './About.css';
import Reveal from '../shared/Reveal';
import swimmerPhoto from '../Hero/assets/header.jpeg';
import {
    LuTimer,
    LuCalendarCheck,
    LuUsers,
    LuClipboardList,
    LuChartLine,
    LuWaves
} from 'react-icons/lu';

// Feature lists follow the app's own role layouts: AthletePages.json and
// CoachPages.json. Nothing here is invented.
const ATHLETE = [
    { Icon: LuTimer, text: 'Measure your Critical Swim Speed and Maximum Swim Speed' },
    { Icon: LuWaves, text: 'Get pace zones calculated from your own result' },
    { Icon: LuCalendarCheck, text: 'Follow a calendar of workouts and races' },
    { Icon: LuChartLine, text: 'Track performance and review races split by split' }
];

const COACH = [
    { Icon: LuClipboardList, text: 'Build periodized programs from those zones' },
    { Icon: LuUsers, text: 'Run squads and take attendance in one sheet' },
    { Icon: LuCalendarCheck, text: 'Schedule preparation and competition blocks' },
    { Icon: LuChartLine, text: 'Watch every athlete from one dashboard' }
];

function RoleList({ items }) {
    return (
        <ul className='lp-role-list'>
            {items.map(({ Icon, text }) => (
                <li key={text}>
                    <Icon className='lp-role-icon' aria-hidden='true' />
                    <span>{text}</span>
                </li>
            ))}
        </ul>
    );
}

export default function About() {
    return (
        <section id='about' className='lp-section lp-about'>
            <div className='lp-wrap'>
                <Reveal>
                    <p className='lp-eyebrow'>About HydroMastery</p>
                    <h2 className='lp-h2 lp-about-h2'>
                        One swimmer's test result becomes the whole squad's plan.
                    </h2>
                    <p className='lp-lede lp-about-lede'>
                        A swimmer completes a timed test set. The platform turns that result into pace
                        zones, and the coach builds the program from them. Both sides read the
                        same numbers.
                    </p>
                </Reveal>

                <div className='lp-about-body'>
                    <div className='lp-roles'>
                        <Reveal className='lp-role' delay={100}>
                            <h3 className='lp-role-title'>For swimmers</h3>
                            <RoleList items={ATHLETE} />
                        </Reveal>

                        <Reveal className='lp-role' delay={200}>
                            <h3 className='lp-role-title'>For coaches</h3>
                            <RoleList items={COACH} />
                        </Reveal>
                    </div>
                    <Reveal as='figure' className='lp-about-photo' delay={120}>
                        <img
                            src={swimmerPhoto}
                            alt='A swimmer pushing off the pool wall underwater at the start of a length'
                            loading='lazy'
                        />
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
